import script from "./user-Initial.vue?vue&type=script&setup=true&lang=js"
export * from "./user-Initial.vue?vue&type=script&setup=true&lang=js"

import "./user-Initial.vue?vue&type=style&index=0&id=68fcd931&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68fcd931"]])

export default __exports__